import { createContext } from "react";

export type AccordionContextType = {
  addEventListener: (event: string, listener: CallableFunction) => void;
  dispatchEvent: (event: string, payload: Record<string, unknown>) => void;
  removeEventListener: (event: string, listener: CallableFunction) => void;
  isSingle: boolean;
};

export const AccordionContext = createContext<AccordionContextType>({
  addEventListener: (_event: string, _listener: CallableFunction) => {},
  dispatchEvent: (_event: string, _payload: Record<string, unknown>) => {},
  removeEventListener: (_event: string, _listener: CallableFunction) => {},
  isSingle: false,
});
